module.exports = __webpack_public_path__ + "static/media/e-coupon.97633887.png";